import React from "react"
import { Row, Container, Col, Breadcrumb } from "react-bootstrap"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const uri = "/about/"

const AboutPage = ( { location } ) => {
  const searchQuery = location.state?.searchQuery

  return (
  <Layout pageInfo={{ pageName: "about", searchQuery: searchQuery }} >
    <Seo title="About" keywords={[`recipes`, `about`]} description="About page" url={uri}/>

      <Container fluid>
      <Row className="justify-content-left my-3">
        <Breadcrumb>
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>About</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
      <Row>
      <Col className="pb-2">
        <h1>About Us</h1>
      </Col>
      </Row>
      <Row className="d-flex flex-wrap">
        <p><h3>Who are we?</h3>We are a family from Minnesota that enjoys cooking and sharing recipes! <br/>
              The boring stuff... officially, IloveItRecipes.com is owned and operated by Alumiah Inc.</p>
        <p><h3>Where are these recipes from?</h3>These recipes have been gathered from family and friends over many years.</p>
        <p><h3>How can you contact us?</h3>info@ILoveItRecipes.com</p>
        <p><h3>Do we have a privacy policy and terms of conditions?</h3>We thought you'd never ask. Here they are:
        <ul> 
          <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
        </ul>
        </p>
    </Row>
    </Container>
  </Layout>
)
}


export default AboutPage

